import mare1 from '../../photos/Dintorni/Mare 1.jpg';
import mare2 from '../../photos/Dintorni/Mare 3.jpg';
import mare3 from '../../photos/Dintorni/Mare 5.jpg';
import mare4 from '../../photos/Dintorni/Mare 6.jpg';
import mare5 from '../../photos/Dintorni/Mare 7.jpg';
import mare6 from '../../photos/Dintorni/Mare 8.jpg';
import mare7 from '../../photos/Dintorni/Mare 9.jpg';
import mare8 from '../../photos/Dintorni/Mare 10.jpg';

import maremdr1 from '../../photos/Marina di Ragusa/Mare Marina di Ragusa.jpg';
import maremdr2 from '../../photos/Marina di Ragusa/Mare Marina di Ragusa 2.jpg';
import spiaggia_punta_di_mola from '../../photos/Dintorni/Spiaggia Punta di Mola.jpg';
import spiaggia1 from '../../photos/Dintorni/Spiaggia 1.jpg';
import spiaggia2 from '../../photos/Marina di Ragusa/Spiaggia Marina di Ragusa.jpg';
import porto1 from '../../photos/Marina di Ragusa/Porto Marina di Ragusa 1.jpg';
import porto2 from '../../photos/Marina di Ragusa/Porto Marina di Ragusa 2.jpg';
import ciclabile2 from '../../photos/Marina di Ragusa/Pista ciclabile Marina di Ragusa 2.jpg';
import tramonto from '../../photos/Marina di Ragusa/Tramonto Marina di Ragusa.jpg';


const DataLandingPage = [
    {
        src: mare1,
        title: 'Mare',
        description: '',
    },
    {
        src: mare2,
        title: 'Mare',
        description: '',
    },
    {
        src: mare3,
        title: 'Mare',
        description: '',
    },
    {
        src: mare4,
        title: 'Mare',
        description: '',
    },
    {
        src: mare5,
        title: 'Mare',
        description: '',
    },
    {
        src: mare6,
        title: 'Mare',
        description: '',
    },
    {
        src: mare7,
        title: 'Mare',
        description: '',
    },
    {
        src: mare8,
        title: 'Mare',
        description: '',
    },
    {
        src: maremdr1,
        title: 'Mare',
        description: 'Mare di Marina di Ragusa',
    },
    {
        src: maremdr2,
        title: 'Mare',
        description: 'Mare di Marina di Ragusa',
    },
    {
        src: spiaggia_punta_di_mola,
        title: 'Spiaggia',
        description: 'Spiaggia di Punta di Mola',
    },
    {
        src: spiaggia1,
        title: 'Spiaggia',
        description: '',
    },
    {
        src: spiaggia2,
        title: 'Spiaggia',
        description: 'Spiaggia di Marina di Ragusa',
    },
    {
        src: porto1,
        title: 'Porto',
        description: 'Porto di Marina di Ragusa',
    },
    {
        src: porto2,
        title: 'Porto',
        description: 'Porto di Marina di Ragusa',
    },
    {
        src: ciclabile2,
        title: 'Pista ciclabile',
        description: 'Pista ciclabile di Marina di Ragusa',
    },
    {
        src: tramonto,
        title: 'Tramonto',
        description: 'Tramonto di Marina di Ragusa',
    },
]
export default DataLandingPage;